export default {
  picks: {
    imageImport: {
      dropzoneBody: "Importe uma foto e nós capturamos as escolhas para você.",
      dropzoneCta: "Clique aqui ou arraste e solte para enviar",
      preparingResults: "Preparando resultados",
      adding: "Adicionando...",
      importedPicks: "Escolhas importadas",
    },
    actions: {
      findTrends: "Encontrar tendências",
    },
    labels: {
      sgpPricingUnavailable: "Preço de SGP indisponível",
    },
    plusPromo: {
      description: "Tenha acesso a jogadas avançadas e insights mais profundos",
    },
  },
};
